import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

const CONTAINER_STYLES =
  'flex flex-col bg-contentareabackgroundalt border-l-[10px] border-actionable relative'

const DISMISS_BTN_STYLES =
  'text-actionable absolute top-2 right-2 text-2xl bg-transparent border-none hover:text-secondary transition-colors'

export type DismissFn = () => void

export interface DismissableProps {
  onDismiss?: DismissFn
  className?: string
  paddingClassName?: string
}

export const Dismissable: React.FC<PropsWithChildren<DismissableProps>> = ({
  onDismiss: handleDismiss,
  children,
  className,
  /**
   * Optional prop to override the default padding
   */
  paddingClassName = 'p-4',
}) => (
  <div
    className={concatStyles([CONTAINER_STYLES, className, paddingClassName])}
  >
    {children}
    {handleDismiss ? (
      <button className={DISMISS_BTN_STYLES} onClick={handleDismiss}>
        <span className="p-2">
          <FontAwesomeIcon icon={faTimesCircle} />
        </span>
      </button>
    ) : null}
  </div>
)
